import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { Community } from ".";

const createCustomFilter = createCustomFilterForEntity<Community>();

export class CommunityFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<Community>
  >((filters) => {
    return filterWithRelationsAndJson(Community)(filters);
  });
}
